/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppUpdateTranscriptionWordsFragmentDetailMutationRequest, WebAppUpdateTranscriptionWordsFragmentDetailMutationResponse, WebAppUpdateTranscriptionWordsFragmentDetailPathParams, WebAppUpdateTranscriptionWordsFragmentDetail404 } from "../models/WebAppUpdateTranscriptionWordsFragmentDetail";

export function getWebAppUpdateTranscriptionWordsFragmentDetailUrl(id: WebAppUpdateTranscriptionWordsFragmentDetailPathParams["id"]) {
  const res = { method: 'PUT', url: `/web-app/v1/fragments/${id}/transcription/words` as const }
  return res
}

/**
 * @summary Replace fragment transcription words
 * {@link /web-app/v1/fragments/:id/transcription/words}
 */
export async function webAppUpdateTranscriptionWordsFragmentDetail(id: WebAppUpdateTranscriptionWordsFragmentDetailPathParams["id"], data: WebAppUpdateTranscriptionWordsFragmentDetailMutationRequest, config: Partial<RequestConfig<WebAppUpdateTranscriptionWordsFragmentDetailMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<WebAppUpdateTranscriptionWordsFragmentDetailMutationResponse, ResponseErrorConfig<WebAppUpdateTranscriptionWordsFragmentDetail404>, WebAppUpdateTranscriptionWordsFragmentDetailMutationRequest>({ method : "PUT", url : getWebAppUpdateTranscriptionWordsFragmentDetailUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}